import type { ReactNode } from 'react';

import { Icon, type IconName } from '@/components/Icon/Icon';

import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon: IconName;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  tone?: 'neutral' | 'warn';
}

/** A centred message standing in for content that is not there. */
export function EmptyState({ icon, title, children, action, tone = 'neutral' }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <span className={`${styles.icon} ${styles[tone]}`}>
        <Icon name={icon} size="1.6rem" />
      </span>
      <p className={styles.title}>{title}</p>
      {children ? <div className={styles.text}>{children}</div> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
